export default String.raw`
.reminder-container {
  max-width: 444px;
  background-color: $bgColor;
  color: $primaryColorFont;
  box-sizing: border-box;
  border-radius: 12px;
  box-shadow: 0px 0px 4px 0px $dropContainerShadowColor;
  margin: 24px auto 424px auto;
  padding: 24px;
}

.reminder-container .reminder-header {
  color: $primaryColorFont;
  text-align: left;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  display: block;
}

.reminder-container .reminder-info{
    margin: 24px 20px 24px 0;
    color: $primaryColorFont;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    word-break: break-word;
}

.reminder-container .primary-action-button {
  margin: 0 auto 0;
  width: 100%;
  box-sizing: border-box;
  padding: .8rem 0;
  display: block;
  height: auto;
}

.reminder-container .loginRedirect {
    display: block;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: center;
    color: $iconColors;
    margin-top: 26px;
  }

.reminder-email {
  font-weight: 600;
  word-break: break-word;
}
`